import {
	GetUserOnboardingStatusResponseDto,
	GetUserRegisterHostProfileRequestDto,
	OrderByEnum,
	restRepository,
	UserRole,
} from "@onair/repositories";

export const getFollowersCount = async (hostId: string): number => {
	const { data } = await restRepository.api.getFollowersCount(hostId);

	return data;
};

export const getUserOnboardingStatus = async (
	email: string,
): Promise<GetUserOnboardingStatusResponseDto> => {
	const { data } = await restRepository.api.hostGetUserOnboardingStatus({
		email,
	});

	return data as GetUserOnboardingStatusResponseDto;
};

export const getRegisterHostProfile = async (
	email: string,
): Promise<GetUserRegisterHostProfileRequestDto> => {
	const { data } = await restRepository.api.hostGetRegisterProfile({ email });

	return data as GetUserRegisterHostProfileRequestDto;
};

export interface HostsQueryFilter {
	category?: string;
	unit?: string;
	organizationId?: string;
	orderBy?: string;
	order?: string;
	q?: string;
	limit?: number;
	page?: number;
	skip?: number;
	take?: number;
}
export const getHostList = async (filter: HostsQueryFilter) => {
	const { data } = await restRepository.api.userV2GetAll({
		role: UserRole.HOST,
		...filter,
	});

	return data;
};
export interface HostsListQueryFilter {
	category?: string;
	unit?: string;
	organizationId?: string;
	orderBy?: string;
	order?: OrderByEnum;
	q?: string;
	limit?: number;
	cursor?: string;
}
export const getHostListV2 = async (filter?: HostsListQueryFilter) => {
	const { data } = await restRepository.api.userV2GetList({
		role: UserRole.HOST,
		...(filter || {}),
	});

	return data;
};
